import { render } from "./AdvancesView.vue?vue&type=template&id=3e96b49b&scoped=true&ts=true"
import script from "./AdvancesView.vue?vue&type=script&lang=ts"
export * from "./AdvancesView.vue?vue&type=script&lang=ts"

import "./AdvancesView.vue?vue&type=style&index=0&id=3e96b49b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e96b49b"]])

export default __exports__